import PropTypes from 'prop-types';
import { withContext } from 'recompose';

const WithKioskContext = withContext(
  { kiosk: PropTypes.bool.isRequired },
  () => ({
    kiosk: true,
  })
);

export default WithKioskContext;



// WEBPACK FOOTER //
// ./src/app/hoc/WithKioskContext.js